import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Kata sandi berhasil diatur ulang. Silakan masuk.");
      navigate("/login");
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Atur ulang kata sandi" subtitle="Masukkan kata sandi baru Anda."
      footer={<Link to="/login" className="text-teal font-semibold">Kembali ke masuk</Link>}>
      {!token ? (
        <div className="bg-red-50 text-red-700 text-sm rounded-xl p-3">Tautan tidak valid.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && <div className="bg-red-50 text-red-700 text-sm rounded-xl p-3">{error}</div>}
          <div>
            <Label htmlFor="password">Kata Sandi Baru</Label>
            <Input id="password" data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-12 mt-1" placeholder="Minimal 6 karakter" />
          </div>
          <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full h-12 rounded-full bg-teal hover:bg-teal-hover font-semibold">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Simpan Kata Sandi"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
